import React, {lazy, Suspense} from 'react';
import Loader from '../Loader/Waiting'

const PaymentHeader = lazy(() => import('./PaymentHeader'));
const PaymentBody = lazy(() => import('./PaymentBody'));

const Payment = () => {
  return (
    <div className='dashboard'>
      <Suspense fallback={<Loader />}>
        <PaymentHeader />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <PaymentBody />
      </Suspense>
    </div>
  )
};

export default Payment;
